import { Input } from "@tine/designsystem-ui-react";
import { type ChangeEvent, useContext, useState } from "react";
import type { ValidatedInputProps } from "../../common/types/formTypes";
import { FormContext } from "./FormContext";
import { validateNotEmpty } from "./FormUtils/FieldValidators";
import useFormError from "./FormUtils/useFormErrors";
import useRegisterfield from "./FormUtils/useRegisterField";

const ValidatedInput = ({
   initialValue,
   validator = validateNotEmpty,
   label,
   name,
   type = "text",
   required = false,
   ...inputProps
}: ValidatedInputProps) => {
   const [showError, setShowError] = useState(false);
   const { updateFormValues, formValues } = useContext(FormContext);

   const hasMoreThanOneField = Object.keys(formValues).length > 1;

   const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      setShowError(false);
      updateFormValues({
         ...formValues[name],
         value,
         error: validator(value, required)
      });
   };

   const handleBlur = (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      const error = validator(value, required);
      setShowError(!!error);
      updateFormValues({
         ...formValues[name],
         value,
         error: validator(value, required)
      });
   };

   useRegisterfield(name, initialValue, validator, required);
   useFormError(setShowError, validator, name, required);

   return (
      <Input
         {...inputProps}
         value={(formValues[name]?.value as string) || ""}
         name={name}
         type={type}
         label={required && hasMoreThanOneField ? `${label} *` : label}
         onFocus={() => setShowError(false)}
         onChange={handleChange}
         onBlur={handleBlur}
         errorMessage={formValues[name]?.error}
         showErrorMessage={showError}
      />
   );
};

export default ValidatedInput;
